import { ContractVersion } from '~/typings/context';
import { ContractTag } from '~/typings/graphql';

export const TEST_TERMS = {
  general: [
    {
      id: 612,
      contractId: 31,
      contractType: 'privacy',
      displayName: 'Privacy Policy',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 820,
      contractId: 43,
      contractType: 'terms',
      displayName: 'General Terms of Service',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  waitlist: [
    {
      id: 612,
      contractId: 31,
      contractType: 'privacy',
      displayName: 'Privacy Policy',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 820,
      contractId: 43,
      contractType: 'terms',
      displayName: 'General Terms of Service',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 77181,
      contractId: 1,
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  illinoisABP: [
    {
      id: 77507,
      contractId: 38,
      contractType: 'disclosure',
      displayName: 'Illinois Shines Community Disclosure Form',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  standardSolar: [
    {
      id: 77181,
      contractId: 1,
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 77177,
      contractId: 2,
      contractType: 'disclosure',
      displayName: 'Community Distributed Generation Disclosure Form',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 77214,
      contractId: 3,
      contractType: 'direct',
      displayName: 'Community Distributed Generation Credit Sale and Purchase Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  nysegSolar: [
    {
      id: 77181,
      contractId: 4,
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 51029,
      displayName: 'E-billing Consent',
      contractId: 5,
      contractType: 'data-consent',
      fileUrl: '',
      scrollRequired: false,
      tag: ContractTag.Nyseg,
    },
  ],
  scrollableSolar: [
    {
      id: 77181,
      contractId: 6,
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 679,
      contractId: 16,
      contractType: 'disclosure',
      displayName: 'SMART Participant Customer Disclosure Form',
      scrollRequired: true,
      fileUrl: '/scrollable-contract-679.pdf',
    },
  ],
  lmi: [
    {
      contractType: 'lmi',
      displayName: 'Subscriber Verification of Low to Moderate Income Status',
      fileUrl: '',
      id: 76900,
      contractId: 8,
      scrollRequired: false,
    },
  ],
  taggedLmi: [
    {
      contractType: 'lmi',
      displayName: 'Subscriber Verification of Low to Moderate Income Status',
      fileUrl: '',
      id: 76900,
      contractId: 8,
      scrollRequired: false,
      tag: ContractTag.Energywell,
    },
  ],
  perchEnergy: [
    {
      id: 612,
      contractId: 31,
      contractType: 'privacy',
      displayName: 'Perch Privacy Policy',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 820,
      contractId: 43,
      contractType: 'terms',
      displayName: 'ESIGN Consent Policy',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 823,
      contractId: 44,
      contractType: 'terms',
      displayName: 'Perch Terms of Service',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
  perchEnergyPersonalized: [
    {
      id: 612,
      contractId: 31,
      contractType: 'privacy',
      displayName: 'Perch Privacy Policy',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: true,
      perchPersonalizedError: null,
      base64PerchPersonalizedFile: 'data:application/pdf;base64,abc',
    },
    {
      id: 820,
      contractId: 43,
      contractType: 'terms',
      displayName: 'ESIGN Consent Policy',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: true,
      perchPersonalizedError: null,
      base64PerchPersonalizedFile: 'data:application/pdf;base64,def',
    },
    {
      id: 823,
      contractId: 44,
      contractType: 'terms',
      displayName: 'Perch Terms of Service',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: false,
      perchPersonalizedError: null,
      base64PerchPersonalizedFile: null,
    },
  ],
  perchEnergyPersonalizedWithErrors: [
    {
      id: 612,
      contractId: 31,
      contractType: 'privacy',
      displayName: 'Perch Privacy Policy',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: true,
      perchPersonalizedError: null,
      base64PerchPersonalizedFile: 'data:application/pdf;base64,abc',
    },
    {
      id: 820,
      contractId: 43,
      contractType: 'terms',
      displayName: 'ESIGN Consent Policy',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: true,
      perchPersonalizedError: 'Error fetching personalized file',
      base64PerchPersonalizedFile: null,
    },
    {
      id: 823,
      contractId: 44,
      contractType: 'terms',
      displayName: 'Perch Terms of Service',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: false,
      perchPersonalizedError: null,
      base64PerchPersonalizedFile: null,
    },
  ],
  perchEnergyPersonalizedWithNestedErrors: [
    {
      id: 612,
      contractId: 31,
      contractType: 'privacy',
      displayName: 'Perch Privacy Policy',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: true,
      perchPersonalizedError: null,
      base64PerchPersonalizedFile: 'data:application/pdf;base64,abc',
    },
    {
      id: 820,
      contractId: 43,
      contractType: 'terms',
      displayName: 'ESIGN Consent Policy',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: true,
      perchPersonalizedError: null,
      base64PerchPersonalizedFile: null,
      base64PerchPersonalizedFiles: [
        {
          utilityAccountId: 101,
          base64PerchPersonalizedFile: null,
          perchPersonalizedError: 'Error fetching personalized file for utility account',
        },
      ],
    },
    {
      id: 823,
      contractId: 44,
      contractType: 'terms',
      displayName: 'Perch Terms of Service',
      fileUrl: '',
      scrollRequired: false,
      hasPersonalization: false,
      perchPersonalizedError: null,
      base64PerchPersonalizedFile: null,
    },
  ],
  mnLmi: [
    {
      contractType: 'disclosure',
      displayName: 'Community Solar Subscriber Information Disclosure Form',
      fileUrl: '',
      id: 78757,
      contractId: 1302,
      scrollRequired: true,
      tag: null,
    },
  ],
  DirectAndDisclosure: [
    {
      contractType: 'direct_and_disclosure',
      displayName: 'Solar disclosure form and Community Solar agreement',
      fileUrl: '',
      id: 79201,
      contractId: 1470,
      scrollRequired: false,
      tag: null,
    },
  ],
  consent: [
    {
      id: 112,
      contractId: 11111,
      contractType: 'consent',
      displayName: 'Consent to Credit Check',
      internalName: 'perch-credit-check-consent',
      notes:
        'I authorize Perch Energy to obtain my credit report from a consumer reporting agency. I understand that this credit report will be used to determine my eligibility for services and may impact my credit score.',
      fileUrl: '',
      scrollRequired: false,
    },
    {
      id: 113,
      contractId: 11234,
      contractType: 'consent',
      displayName: 'Consent to Phone Check',
      internalName: 'perch-phone-number-consent',
      notes:
        'I authorize Perch Energy to obtain my phone number from a consumer reporting agency. I understand that this phone number will be used to determine my eligibility for services and may impact my credit score.',
      fileUrl: '',
      scrollRequired: false,
    },
  ],
} satisfies Record<string, Partial<ContractVersion>[]>;
